import React from "react";
import GlobalContext from "./GlobalContext.js";
import { useLocation } from "react-router-dom";
const GlobalProvider = (props) => {
    const { children, ...otherProps } = props;
    const { search } = useLocation();
    const showCopyTags = props.isInternal && search?.includes("show_tags=1");
    const showRankingXray = props.isInternal && search?.includes("show_ranking_xray=1");
    return (React.createElement(GlobalContext.Provider, { value: { ...otherProps, showCopyTags, showRankingXray } }, children));
};
export default GlobalProvider;
